import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../../../../../modules/shared/services/shared.service";

import { ActivatedRoute } from "@angular/router";

@Component({
    selector: "calendar-config",
    templateUrl: "./calendar-config.view.html",
    providers: []
})
export class CalendarConfigView implements OnInit {
    baseUrl = '';
    calendarConfig: any = {};
    calendarConfigObj: any = {};

    constructor(public sharedService: SharedService, private activatedRoute: ActivatedRoute) {
        if (this.activatedRoute.parent.routeConfig.path == "session") {
            this.baseUrl = sharedService.sessionUrl;
            this.calendarConfig = this.sharedService.sessionLayoutConfig[this.baseUrl].my_schedule.calenderConfig
            this.sharedService.sessionLayoutConfig[this.baseUrl].my_schedule.calenderConfig = this.calendarConfig;
        }
    }

    ngOnInit() {}

    toggleHTMLEnable(e,type) {
        this.calendarConfig[type] = !this.calendarConfig[type];
    }
}
